//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 站外谷歌搜索
 * @author blake
 */
import { getQueryValue } from "@/utils/index";

const searchUrlList = {
  en: "https://www.google.com/search",
  zh: "https://www.baidu.com/",
  ja: "https://www.google.co.jp/search",
  fr: "https://www.google.fr/search",
  de: "https://www.google.de/search",
  it: "https://www.google.it/search",
  sv: "https://www.google.se/search",
  nl: "https://www.google.nl/search",
  es: "https://www.google.es/search",
  fi: "https://www.google.fi/search",
  no: "https://www.google.no/search",
  da: "https://www.google.dk/search",
  tr: "https://www.google.com.tr/search",
  pl: "https://www.google.pl/search",
  tw: "https://www.google.com.tw/search",
  hu: "https://www.google.hu/search",
  cs: "https://www.google.cz/search",
  el: "https://www.google.gr/search",
  pt: "https://www.google.com.br/search",
};

export default {
  name: "GoogleSearch",
  componentName: "GoogleSearch",
  data() {
    return {
      showInputArea: false,
      searchDomain: "https://www.google.com/search",
      domain: "picwish.com",
    };
  },
  mounted() {
    const lang = getQueryValue("lang") || document.documentElement.lang || "en";
    if (searchUrlList[lang]) {
      this.searchDomain = searchUrlList[lang];
    }
    let url = window.location.href.substring(
      0,
      window.location.href.lastIndexOf("/")
    );
    this.domain = url.replace("https://", "");
  },
  methods: {
    clickToSearch() {
      if (!this.showInputArea) {
        this.showInputArea = true;
        this.$refs.inputEl.focus();
      }
    },
    closeSearch() {
      this.showInputArea = false;
      this.$refs.inputEl.value = "";
    },
  },
};
